import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { ImageCropDialogComponent } from './image-crop-dialog.component';

@Injectable({ providedIn: 'root' })
export class ImageCropDialogService extends AbstractDialogService<
  undefined,
  Blob | undefined,
  typeof ImageCropDialogComponent
> {
  readonly id = 'image-crop-dialog';
  protected readonly component = ImageCropDialogComponent;

  override readonly options = {
    cssClass: 'action-sheet-on-mobile',
  };
}
